import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage, { Section, Champ } from '../components/LegalPage';
import { EDITEUR, PRIX_AFFICHES } from '../legalInfo';

export default function CGV() {
  return (
    <LegalPage
      titre="Conditions générales de vente"
      chapo="Les présentes CGV régissent l'abonnement à la plateforme Jalonne, conclu par contrat écrit avec l'Éditeur. Elles complètent les CGU, qui régissent l'utilisation du service."
    >
      <Section titre="1. Champ d'application">
        <p>
          Le service est proposé exclusivement à des <strong>professionnels</strong> agissant pour
          les besoins de leur activité. La signature du contrat vaut acceptation des présentes CGV, qui
          prévalent sur tout document contraire du Client, notamment ses conditions générales
          d'achat.
        </p>
        <p>
          Conformément à l'article L. 221-3 du code de la consommation, le professionnel employant
          cinq salariés ou moins et souscrivant hors du champ de son activité principale peut
          bénéficier des dispositions protectrices des consommateurs ; il lui appartient de le
          signaler avant la signature du contrat.
        </p>
      </Section>

      <Section titre="2. Formules et prix">
        <p>
          La formule, les fonctionnalités incluses et le prix sont fixés par le contrat ou le devis
          signé entre l'Éditeur et le Client.
        </p>
        <p>
          Les prix sont exprimés en euros,{' '}
          <Champ valeur={PRIX_AFFICHES ? (PRIX_AFFICHES === 'HT' ? 'hors taxes (HT)' : 'toutes taxes comprises (TTC)') : null}
            attendu="préciser « hors taxes » ou « toutes taxes comprises »" />
          {PRIX_AFFICHES === 'HT' ? ', la TVA au taux en vigueur s\'y ajoutant' : ''}.
        </p>
        {EDITEUR.franchiseTva && (
          <p>
            <strong>TVA non applicable, article 293 B du code général des impôts.</strong> L'Éditeur
            relève de la franchise en base : le prix affiché est celui effectivement dû, aucune TVA
            n'est facturée et aucune TVA n'est donc récupérable par le Client.
          </p>
        )}
      </Section>

      <Section titre="3. Conclusion du contrat">
        <p>
          Le service n'est pas vendu en ligne. Le contrat est conclu par la signature d'un devis ou
          d'un contrat écrit ; l'Éditeur crée ensuite l'espace du Client et lui transmet ses accès.
        </p>
      </Section>

      <Section titre="4. Facturation et paiement">
        <p>
          L'abonnement est facturé selon la périodicité et les modalités de paiement prévues au
          contrat. Les factures sont adressées au Client par email.
        </p>
      </Section>

      <Section titre="5. Défaut de paiement">
        <p>
          En cas de facture impayée à l'échéance, l'Éditeur peut, après une mise en demeure restée
          sans effet pendant sept (7) jours, suspendre l'accès au service jusqu'au règlement.
        </p>
        <p>
          Conformément aux articles L. 441-10 et D. 441-5 du code de commerce, toute somme impayée à
          l'échéance donne lieu à des pénalités de retard au taux d'intérêt appliqué par la Banque
          centrale européenne à son opération de refinancement la plus récente, majoré de 10 points
          de pourcentage, ainsi qu'à une indemnité forfaitaire de 40 € pour frais de recouvrement.
        </p>
      </Section>

      <Section titre="6. Durée, reconduction et résiliation">
        <p>
          La durée de l'abonnement est fixée au contrat. À défaut, il est conclu pour une durée d'un
          mois, reconduit tacitement par périodes d'un mois, sauf résiliation.
        </p>
        <p>
          Sauf stipulation contraire du contrat, le Client peut résilier à tout moment par écrit
          (courrier ou email adressé à l'Éditeur). La résiliation
          prend effet au terme de la période en cours : le service reste accessible jusqu'à
          l'échéance, et aucun remboursement au prorata n'est dû pour la période entamée.
        </p>
        <p>
          L'Éditeur peut résilier moyennant un préavis de trente (30) jours, ou sans préavis en cas
          de manquement grave du Client au sens de l'article 9 des <Link to="/cgu">CGU</Link>.
        </p>
      </Section>

      <Section titre="7. Changement de formule">
        <p>
          Le Client peut demander à changer de formule à tout moment. Le changement fait l'objet d'un
          avenant ou d'un nouveau devis, qui en fixe la date d'effet et le prix.
        </p>
      </Section>

      <Section titre="8. Droit de rétractation">
        <p>
          Le Client agissant en qualité de professionnel dans le champ de son activité principale ne
          bénéficie pas du droit de rétractation prévu aux articles L. 221-18 et suivants du code de
          la consommation.
        </p>
        <p>
          Le Client relevant de l'article L. 221-3 précité dispose d'un délai de quatorze (14) jours
          pour se rétracter. S'il demande expressément l'exécution immédiate du service pendant ce
          délai, il reste redevable du montant correspondant à la prestation déjà fournie.
        </p>
      </Section>

      <Section titre="9. Responsabilité">
        <p>
          L'Éditeur est tenu d'une obligation de moyens. Sa responsabilité est limitée aux dommages
          directs et prévisibles, et ne peut excéder le montant total des sommes effectivement
          versées par le Client au titre des douze (12) mois précédant le fait générateur.
        </p>
        <p>
          Sont exclus les dommages indirects, notamment la perte d'exploitation, de chiffre
          d'affaires, de clientèle, de données ou d'image. Aucune de ces limitations ne s'applique en
          cas de faute lourde, de dol ou d'atteinte aux personnes.
        </p>
      </Section>

      <Section titre="10. Réversibilité et sort des données">
        <p>
          Le Client peut à tout moment exporter l'intégralité de ses données depuis son espace, sous
          la forme d'une archive contenant ses données structurées et ses photographies.
        </p>
        <p>
          À l'issue du contrat, les données sont conservées <strong>trente (30) jours</strong> afin
          de permettre une réactivation ou un export tardif, puis supprimées définitivement. Le
          Client peut demander leur suppression immédiate depuis son espace. Les documents
          comptables sont conservés conformément aux obligations légales (article 11).
        </p>
      </Section>

      <Section titre="11. Conservation légale des factures">
        <p>
          Les factures sont conservées dix (10) ans conformément à l'article L. 123-22 du code de
          commerce, indépendamment de la suppression des données du Client.
        </p>
      </Section>

      <Section titre="12. Force majeure">
        <p>
          Aucune partie n'est responsable d'un manquement résultant d'un événement de force majeure
          au sens de l'article 1218 du code civil. Si l'empêchement se prolonge au-delà de trente
          (30) jours, chaque partie peut résilier de plein droit, sans indemnité.
        </p>
      </Section>

      <Section titre="13. Données personnelles">
        <p>
          Le traitement des données du Client est décrit dans la{' '}
          <Link to="/confidentialite">politique de confidentialité</Link>. Le traitement, par
          l'Éditeur pour le compte du Client, des données des personnes concernées par les chantiers
          est régi par l'<Link to="/sous-traitance">accord de sous-traitance</Link>, qui fait partie
          intégrante du contrat.
        </p>
      </Section>

      <Section titre="14. Modification des CGV">
        <p>
          L'Éditeur peut modifier les présentes CGV et ses tarifs. Toute modification est notifiée
          par email au moins trente (30) jours avant son entrée en vigueur. Le Client qui la refuse
          peut résilier sans frais avant cette date ; à défaut, la modification est réputée acceptée.
          Les tarifs en cours ne sont jamais modifiés en cours de période payée.
        </p>
      </Section>

      <Section titre="15. Droit applicable et litiges">
        <p>
          Les présentes CGV sont soumises au droit français. Les parties rechercheront une solution
          amiable avant toute action, en écrivant à{' '}
          <Champ valeur={EDITEUR.email} attendu="email de contact" />. À défaut d'accord, le litige
          relève de la compétence exclusive des tribunaux du ressort de l'établissement principal de l'Éditeur.
        </p>
      </Section>
    </LegalPage>
  );
}
